import {ViewerInfoVo} from '../../common/shared/api/gateway/viewer/ViewerInfoVo.interface';
import {ViewerInfo} from '../generated/types';
import {createDisplayAd} from './DisplayAd';
import {createNearItem} from './NearItem';
import {createSeries} from './Series';
import {createSingle} from './Single';
import {createViewerData} from './ViewerData';

export function createViewerInfo({
  item,
  series_item,
  next_item,
  prev_item,
  viewer_data,
  display_ad,
}: ViewerInfoVo): ViewerInfo {
  return {
    item: createSingle(item),
    seriesItem: createSeries(series_item),
    nextItem: next_item && createNearItem(next_item),
    prevItem: prev_item && createNearItem(prev_item),
    viewerData: createViewerData(viewer_data),
    // displayAd는 현재 톡뷰어 외에 사용되지 않습니다. 정책상 전체작품 무료가 아니면 DA를 노출시키지 않습니다.
    displayAd:
      !!display_ad && series_item.is_all_free
        ? createDisplayAd(display_ad)
        : undefined,
  };
}
